import { SearchInput } from '@shared/components'
import { Space } from 'antd'

export const AgentsHeader = () => {
  return (
    <Space>
      <SearchInput />
    </Space>
  )
}
